module.exports = __webpack_public_path__ + "img/product10.268b5153.jpg";